import { getFunctionSigHash } from '../utils/getFunctionSigHash';
import { encodeDataForLinkingSmartAccount } from '../utils/encodeDataForLinkingSmartAccount';
import { isAddress } from 'viem';
/**
 * User operation to link smart account wallet to the root key.
 * @param args
 */
export async function linkSmartAccountAndEOAAndSetDefaultWallet(params) {
    const { spaceDapp, rootKeySigner, smartAccountAddress, externalWalletSigner, smartAccount } = params;
    if (!spaceDapp) {
        throw new Error('spaceDapp is required');
    }
    const rootKeySignerAddress = await rootKeySigner.getAddress();
    const externalWalletSignerAddress = await externalWalletSigner.getAddress();
    if (!isAddress(externalWalletSignerAddress)) {
        throw new Error('externalWalletSignerAddress is not a valid address');
    }
    if (!isAddress(rootKeySignerAddress)) {
        throw new Error('rootKeySignerAddress is not a valid address');
    }
    const walletLink = spaceDapp.walletLink;
    const functionName = 'linkCallerToRootKey';
    const functionHashForPaymasterProxy = getFunctionSigHash(walletLink.getInterface(), functionName);
    // Get the current nonce
    const baseNonce = await walletLink.walletLinkShim.read.getLatestNonceForRootKey(rootKeySignerAddress);
    const smartAccountLinkNonce = baseNonce;
    const externalWalletLinkNonce = baseNonce.add(1);
    const callDataForLinkingSmartAccount = await encodeDataForLinkingSmartAccount(spaceDapp, rootKeySigner, smartAccountAddress, smartAccountLinkNonce);
    const callDataForLinkingWallet = await spaceDapp.walletLink.encodeLinkWalletToRootKey(rootKeySigner, externalWalletSigner, externalWalletLinkNonce);
    const callDataForSettingDefaultWallet = spaceDapp.walletLink.walletLinkShim.encodeFunctionData('setDefaultWallet', [externalWalletSignerAddress]);
    return smartAccount.sendUserOp({
        toAddress: [
            spaceDapp.walletLink.address,
            spaceDapp.walletLink.address,
            spaceDapp.walletLink.address,
        ],
        callData: [
            callDataForLinkingSmartAccount,
            callDataForLinkingWallet,
            callDataForSettingDefaultWallet,
        ],
        signer: rootKeySigner,
        spaceId: undefined,
        functionHashForPaymasterProxy,
    });
}
